import { useTheme } from '../../hooks/useTheme';
import '../../asset/css/main.css';

export default function Topbar({ title, onMenuClick }) {
  const { theme, toggle } = useTheme();

  return (
    <header className="topbar">
      <button className="tb-hamburger" onClick={onMenuClick} aria-label="Toggle menu">
        <span /><span /><span />
      </button>

      <div className="tb-title">{title}</div>

      <div className="tb-search">
        <span style={{ color: 'var(--muted)', fontSize: '0.88rem' }}>🔍</span>
        <input placeholder="Search…" aria-label="Search" />
      </div>

      <div className="tb-actions">
        <button className="tb-theme-toggle" onClick={toggle}>
          {theme === 'dark' ? '☀️' : '🌙'}
          <span>{theme === 'dark' ? 'Light' : 'Dark'}</span>
        </button>
        <div className="tb-icon">
          🔔 <span className="tb-notif" />
        </div>
        <div className="tb-icon">⚙️</div>
      </div>
    </header>
  );
}